import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export type BrowserPageState = {
  isPageReloading: boolean;
};

const browserPageInitialState: BrowserPageState = {
  isPageReloading: false,
};

export const { reducer: browserPageReducer, actions: browserPageActions } = createSlice({
  initialState: browserPageInitialState,
  name: 'browserPage',
  reducers: {
    setIsPageReloading(state, action: PayloadAction<boolean>) {
      state.isPageReloading = action.payload;
    },
  },
});
